import React from "react";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";

const PortfolioCompanyCard = ({ name, focus, description }) => (
  <Card
    sx={{
      height: "100%",
      border: "1px solid rgba(255,255,255,0.06)",
      background:
        "linear-gradient(180deg, rgba(14,25,40,1) 0%, rgba(18,32,51,0.98) 52%, rgba(24,41,64,0.96) 100%)",
      color: "#fff",
      overflow: "hidden",
      transition: "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "var(--shadow-hero)",
        borderColor: "rgba(222, 192, 149, 0.2)",
      },
    }}
  >
    <CardContent sx={{ p: { xs: 2.95, md: 3.45 }, position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          inset: "auto -10% -18% auto",
          width: 180,
          height: 180,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(183,132,69,0.18), transparent 68%)",
          pointerEvents: "none",
        }}
      />
      <Chip
        label={focus}
        size="small"
        sx={{
          mb: 2.2,
          bgcolor: "rgba(184, 134, 70, 0.18)",
          color: "#fff",
          border: "1px solid rgba(216, 184, 131, 0.34)",
        }}
      />
      <Typography variant="h5" sx={{ mb: 1.15, maxWidth: "16ch", position: "relative" }}>
        {name}
      </Typography>
      <Typography variant="subtitle2" sx={{ color: "primary.light", mb: 1.35, position: "relative", maxWidth: "22ch" }}>
        Operating company
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "rgba(255,255,255,0.78)", position: "relative" }}
      >
        {description}
      </Typography>
    </CardContent>
  </Card>
);

export default PortfolioCompanyCard;
